import { useQuery } from '@tanstack/react-query';

const API_BASE_URL = import.meta.env.VITE_API_URL;

interface Video {
  id: number;
  name: string;
  [key: string]: unknown;
}

interface UserVideosResponse {
  data: Video[];
}

const fetchUserVideos = async (): Promise<Video[]> => {
  const response = await fetch(`${API_BASE_URL}/services/userVideos`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch videos: ${response.status}`);
  }

  const result: UserVideosResponse = await response.json();
  return result.data ?? [];
};

export const userVideosQueryKey = () => ['user-videos'] as const;

export const useUserVideosQuery = () => {
  return useQuery({
    queryKey: userVideosQueryKey(),
    queryFn: () => fetchUserVideos(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });
};
